import React, { useState } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import Spinner from '../spinner';

interface APIProviderGoogleMapProps {
  children: JSX.Element;
  mapApiKey: string;
  libraries: string[];
}

const APIProviderGoogleMap = ({ children, mapApiKey, libraries }: APIProviderGoogleMapProps) => {
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  return (
    <APIProvider apiKey={mapApiKey} libraries={libraries} onLoad={() => setIsApiLoaded(true)}>
      {isApiLoaded ? children : <Spinner />}
    </APIProvider>
  );
};

export default APIProviderGoogleMap;
